import { render, staticRenderFns } from "./widthNew.vue?vue&type=template&id=c4c75dbc&scoped=true&"
import script from "./widthNew.vue?vue&type=script&lang=js&"
export * from "./widthNew.vue?vue&type=script&lang=js&"
import style0 from "./widthNew.vue?vue&type=style&index=0&id=c4c75dbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c75dbc",
  null
  
)

export default component.exports